import styled from '@emotion/styled';

import { IconButton } from '@/design-system';

export const Row = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],
}));

export const ActionButton = styled(IconButton)(({ theme }) => ({
  width: 40,
  height: 40,
  padding: 0,
  color: theme.colors.icon.primary,
}));
